import IService from '../IService';

export default IService.extend({
  /**
   * Fetch produced video preview
   * @note: parallel execution should be allowed by design
   * @param storyId
   */
  get(storyId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl(`/api/v1/producedStoryPreviews/${storyId}`),
        type: 'GET',

        error: (jqXHR) => {
          reject(this.createError(jqXHR));
        },

        dataType: 'json',
        success(response) {
          if (!_.isEmpty(response)) {
            resolve(response);
          } else {
            reject(response);
          }
        },
      });
    });
  },
});
